import { render, staticRenderFns } from "./Eigentuemer.vue?vue&type=template&id=0dd268f9&"
import script from "./Eigentuemer.vue?vue&type=script&lang=js&"
export * from "./Eigentuemer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports